/* eslint-disable @nrwl/nx/enforce-module-boundaries */
// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { BilancioPartecipata } from '@ideapa/app-shared-bilancio-partecipata';
import { BilancioPartecipataDto, ResultDto } from '@ideapa/common-dto';
import { TipoBilancio } from '@ideapa/common-utils';
import { Observable } from 'rxjs';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class BilancioPartecipataApiClient extends BaseCRUDApiClient<BilancioPartecipataDto> {
  baseUrl = this.config.apiEndpoint + '/bilancio-partecipata';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getAllByPartecipata(idPartecipata: number) {
    return this.http.get<BilancioPartecipataDto[]>(
      this.baseUrl + '/idPartecipata/' + idPartecipata
    );
  }

  canImport(body: { idPartecipata: number; esercizio: number }) {
    return this.http.post<{
      bilancioDiEsercizio: boolean;
      bilancioRiclassificato: boolean;
    }>(`${this.baseUrl}/can-import`, body);
  }

  // canDuplicate() {
  //   return this.http.get<boolean>(`${this.baseUrl}/can-duplicate`);
  // }

  updateTotali(idBilancio: number) {
    this._pagedCache.clear();
    return this.http.get<BilancioPartecipata>(
      `${this.baseUrl}/update-totali/${idBilancio}`
    );
  }

  importExcelFile(
    file: File,
    idPartecipata: number,
    esercizio: number,
    tipo: TipoBilancio,
    estremiDelibera: string
  ) {
    this._pagedCache.clear();
    const fd = new FormData();
    fd.append('file', file);
    fd.append('idPartecipata', idPartecipata.toString());
    // fd.append('esercizio', esercizio.toString());
    fd.append('tipo', tipo);
    fd.append('estremiDelibera', estremiDelibera);

    return this.http.post<ResultDto>(
      this.baseUrl + '/import-excel/' + esercizio,
      fd
      // {
      //   fd,
      //   idPartecipata: idPartecipata,
      //   esercizio: esercizio,
      //   tipo: tipo,
      //   estremiDelibera,
      // }
    );
  }

  // duplicate(body: { fromEsercizio: number; toEsercizio: number }) {
  //   return this.http.post<ResultDto>(`${this.baseUrl}/duplicate`, body);
  // }

  importXbrlFile(
    file: File,
    idPartecipata: number,
    esercizio: number,
    estremiDelibera: string
  ) {
    this._pagedCache.clear();
    const fd = new FormData();
    fd.append('file', file);
    fd.append('idPartecipata', idPartecipata.toString());
    fd.append('estremiDelibera', estremiDelibera);
    return this.http.post<ResultDto>(
      this.baseUrl + '/import-xbrl/' + esercizio,
      fd
    );
  }

  setDefaultBilancioPartecipata(
    idBilancioPartecipata: number
  ): Observable<BilancioPartecipata> {
    this._pagedCache.clear();
    return this.http.get<BilancioPartecipata>(
      `${this.baseUrl}/set-default-bilancio-partecipata/${idBilancioPartecipata}`
    );
  }

  unsetDefaultBilancioPartecipata(
    idBilancioPartecipata: number
  ): Observable<BilancioPartecipata> {
    this._pagedCache.clear();
    return this.http.get<BilancioPartecipata>(
      `${this.baseUrl}/unset-default-bilancio-partecipata/${idBilancioPartecipata}`
    );
  }
}
